var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEditBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 31,
    height: 31,
    rx: 7,
    fill: "#25D4A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.2163 21.4081H17.7875C17.3554 21.4081 17.0039 21.7651 17.0039 22.204C17.0039 22.6438 17.3554 23 17.7875 23H22.2163C22.6484 23 22.9999 22.6438 22.9999 22.204C22.9999 21.7651 22.6484 21.4081 22.2163 21.4081Z",
    fill: "#25D4A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6848 12.0363L18.8816 15.4275C18.9828 15.5086 19.0001 15.6574 18.9211 15.7611L13.9457 22.2442C13.6329 22.6447 13.172 22.8712 12.6782 22.8796L9.96208 22.9131C9.81722 22.9147 9.69047 22.8144 9.65755 22.6706L9.04025 19.9867C8.93326 19.4934 9.04025 18.9834 9.35302 18.5904L14.3531 12.0765C14.4338 11.972 14.5827 11.9536 14.6848 12.0363Z",
    fill: "#25D4A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.7603 13.4065L19.9513 14.4164C19.8698 14.5193 19.7233 14.536 19.622 14.4541C18.6385 13.6581 16.1199 11.6155 15.4212 11.0495C15.3191 10.9659 15.3051 10.8171 15.3874 10.7134L16.1677 9.74438C16.8755 8.83304 18.1101 8.74943 19.106 9.54372L20.25 10.4551C20.7192 10.8229 21.0319 11.3079 21.1389 11.8179C21.2624 12.3789 21.1307 12.9299 20.7603 13.4065Z",
    fill: "#25D4A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditBg);
export default __webpack_public_path__ + "static/media/icon-edit-bg.7ce13c5aef05f3896c7b746b6d977f19.svg";
export { ForwardRef as ReactComponent };